import { render, staticRenderFns } from "./ColumnSetting.vue?vue&type=template&id=38625bba&scoped=true"
import script from "./ColumnSetting.vue?vue&type=script&lang=js"
export * from "./ColumnSetting.vue?vue&type=script&lang=js"
import style0 from "./ColumnSetting.vue?vue&type=style&index=0&id=38625bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38625bba",
  null
  
)

export default component.exports